const desc = `
    <p class="c2" dir="rtl">
      <span class="c0">נחמה פוחצ&#39;בסקי, </span
      ><span class="c4">למלאת חמש</span><span class="c0"> שנים למותה  </span
      ><span class="c4 c6 bold">גליונות</span
      ><span class="c0 c1"> כרך ט  תרצ"ט-ת"ש  [1939 05 25]</span>
    </p>`;

export default desc;
